module.exports = __webpack_public_path__ + "static/wsc_logo_small-c8acb078c2b6ab0cfaeb0c483e42ba80.png";